import type { FaireProductEntity } from "../../entity_types/product";

export const p_8ghtfvnbnx: FaireProductEntity = {
  token: "p_8ghtfvnbnx",
  type: "product",
  name: "Self Care Gift Set | Spring-Summer 2026 | Mother's Day",
  brandToken: "b_83y6fhr0",
  brandName: "Latika Beauty",
  imageUrl:
    "https://cdn.faire.com/fastly/a848c30183a07e36b1ced4d63383fa709dead77be75736e21b483c9f5b66e36b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1937987da9a0f5cad98dda15c9607237ef640b9d3baee886fe8ec8e067b5cfdb.jpeg",
    "https://cdn.faire.com/fastly/12fec336e14074b64efb2788234fa7310546cae0904bdd6d223a5bec194e4a5b.jpeg",
    "https://cdn.faire.com/fastly/89cccc59cf8e178207e6f4aadb3de43dd94fa1a7431f5169654a02ef0e957ec1.jpeg",
    "https://cdn.faire.com/fastly/f4c574d1e6d4b84b73d4cbe4586d3b690acee17e074ec73aa57c4456b54bce98.jpeg",
    "https://cdn.faire.com/fastly/ac5d8a326f78ef322082b6680d95b1c6f0bb684f005cca83579b2137604d365f.jpeg",
    "https://cdn.faire.com/fastly/a8ae09d2b82fc297667204fcc7e068a37ea27ba2d896386406e0702d62931ade.jpeg",
    "https://cdn.faire.com/fastly/1af2ffd0f6446d315627cb78e37da4241e38f756d6327bb79c81b85595e76145.jpeg",
    "https://cdn.faire.com/fastly/735c39081047ee42e76551f9fe5bf00b86157edcd065e0c3cdf49bfc75a050dc.jpeg",
    "https://cdn.faire.com/fastly/6b8ff68e09396cb3c30d472ebe9436be44bd7f72746411593a30438884300450.jpeg",
    "https://cdn.faire.com/fastly/9d57a267f34b1fbcb31c93681409d6be2cb7234bc07951c6d1f88f16f5e0d71e.jpeg",
    "https://cdn.faire.com/fastly/5bd32cac935a1bf8c97a134a215159da6cfeb4467b96712c8e535fd573ed4d8c.jpeg",
  ],
  priceDollars: 20.55,
  description:
    "The Self Care Gift Set in White Tea brings together three products in a single ready-to-gift format: the Fine Fragrance Milk Bath Soak, the Fine Fragrance Shower Steamers, and a limited edition White Tea Bar Soap made exclusively for this set.\n\nThe White Tea fragrance is an all-natural custom blend of floral jasmine, citrus peel, ginger tea, and nutmeg. Subtle, balanced, and sophisticated - a scent that reads elevated, designed to move broadly across gifting occasions including everyday self-care, Mother's Day, and birthdays.\n\nThe milk bath soak is formulated with nourishing coconut milk for skin-softening comfort. \n\nAll three products share the same White Tea fragrance, making this a cohesive gift that requires no curation on the customer's part.\n\nMade in small batches at our Liberty Hill, Texas facility. PETA-certified cruelty-free and vegan. FDA and MoCRA compliant. Phthalate-free fragrance throughout.\n\nMade with all-natural fragrance components - without any artificial fragrance or color.\n\nLooks beautiful on the shelf alongside the Magnesium collection. \n\nMother's day collection:\nhttps://www.faire.com/product-based-collection/pbc_dfpnj8gnxm",
  tags: [],
  msrpDollars: 41.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:39.229Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
